import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vueHeadful from 'vue-headful'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeart as farHeart } from '@fortawesome/free-regular-svg-icons'
import { faHeart as fasHeart, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(farHeart, fasHeart, faCaretUp, faCaretDown)

Vue.use(VueApexCharts)
Vue.use(ElementUI)

Vue.component('apexchart', VueApexCharts)
Vue.component('vue-headful', vueHeadful)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('formatDateToMonthYear', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM YYYY')
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
